import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import Utilisateurs from "./Utilisateurs";
import CltUtser from "./cltUtser";
import Pages from "./Pages";
import SecteursActivite from "./SecteurActivite";
import Connexions from "./Connexions";
import Fonction from "./Fonction";
import Dashboad from "./Dashboard";
import Clients from "./Clients";
import Services from "./Services";
import { Navigate } from "react-router-dom";
import { useUser } from "../../Context/UserContext";
import DownloadLogTable from "./Downloads";
import "./Dashboard.css";

export default function DashboardTab() {
  const { user } = useUser();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Detect screen resize and update state
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (
    user.email === "contact-gexonline@gestion.gexpertise.fr" ||
    user.email === "n.benamor@gexpertise.fr"
  ) {
    return (
      <div className="dashboard-container">
        {isMobile ? (
          // Accordion view for mobile devices
          <Accordion className="mobile-accordion">
             {/*  <AccordionTab header="Dashboard">
              <Dashboad />
            </AccordionTab> */ }
            <AccordionTab header="Utilisateurs">
              <Utilisateurs />
            </AccordionTab>
            <AccordionTab header="Clients">
              <Clients />
            </AccordionTab>
            <AccordionTab header="Clients-Utilisateurs">
              <CltUtser />
            </AccordionTab>
            <AccordionTab header="Pages">
              <Pages />
            </AccordionTab>
            
            <AccordionTab header="Connexions">
              <Connexions />
            </AccordionTab>
            <AccordionTab header="Services">
              <Services />
            </AccordionTab>
            <AccordionTab header="Téléchargement">
              <DownloadLogTable />
            </AccordionTab>
          </Accordion>
        ) : (
          // TabView for larger screens
          <TabView className="tabView-dashboard">
           

              {/* 
              <TabPanel header="Dashboard"> 
              <Dashboad /> 
            </TabPanel>
            */}
            <TabPanel header="Utilisateurs">
              <Utilisateurs />
            </TabPanel>
            <TabPanel header="Clients">
              <Clients />
            </TabPanel>
            <TabPanel header="Clients-Utilisateurs">
              <CltUtser />
            </TabPanel>
            <TabPanel header="Pages">
              <Pages />
            </TabPanel>
            
            
            <TabPanel header="Connexions">
              <Connexions />
            </TabPanel>
            <TabPanel header="Services">
              <Services />
            </TabPanel>
            <TabPanel header="Téléchargement">
              <DownloadLogTable />
            </TabPanel>
          </TabView>
        )}
      </div>
    );
  } else {
    return <Navigate to="/carte" replace />;
  }
}
